var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-review-summary" }, [
    _vm.loaded
      ? _c(
          "div",
          { staticClass: "product-review-summary__rating" },
          [
            _c("star-rating", {
              staticClass: "product-review-summary__stars",
              attrs: { rating: _vm.rating }
            }),
            _vm.count > 0
              ? _c(
                  "a",
                  {
                    staticClass: "product-review-summary__count",
                    attrs: { href: "#" }
                  },
                  [_vm._v(_vm._s(_vm.reviewMessage))]
                )
              : _vm.loaded
              ? _c(
                  "a",
                  {
                    staticClass: "product-review-summary__no-ratings",
                    attrs: { href: "#" }
                  },
                  [_vm._v("No reviews yet!")]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }